var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31 38V14.3005L23.8185 13.5446C22.8282 13.4403 21.9541 12.8515 21.4855 11.9728L18.3 6H2V38H31ZM32 40H0.999999C0.447714 40 0 39.5523 0 39V5C0 4.44772 0.447715 4 1 4H18.9C19.2693 4 19.6086 4.20355 19.7824 4.52941L23.2502 11.0316C23.4064 11.3245 23.6978 11.5208 24.0279 11.5556L32.1047 12.4058C32.6136 12.4593 33 12.8885 33 13.4003V39C33 39.5523 32.5523 40 32 40Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5858 11H29C27.3431 11 26 9.65685 26 7.99999V1.41421C26 0.885768 26.1263 0.409486 26.3436 0H5C4.44772 0 4 0.447716 4 1V35C4 35.5523 4.44771 36 5 36H36C36.5523 36 37 35.5523 37 35V10.6564C36.5905 10.8737 36.1142 11 35.5858 11ZM35.5858 8.99999H29C28.4477 8.99999 28 8.55228 28 7.99999V1.41421C28 0.523302 29.0771 0.0771338 29.7071 0.707099L36.2929 7.29289C36.9229 7.92285 36.4767 8.99999 35.5858 8.99999ZM9 16C9 15.4477 9.37884 15 9.84615 15H30.1538C30.6212 15 31 15.4477 31 16C31 16.5523 30.6212 17 30.1538 17H9.84616C9.37884 17 9 16.5523 9 16ZM9 22C9 21.4477 9.37884 21 9.84615 21H30.1538C30.6212 21 31 21.4477 31 22C31 22.5523 30.6212 23 30.1538 23H9.84616C9.37884 23 9 22.5523 9 22ZM9.84615 27C9.37884 27 9 27.4477 9 28C9 28.5523 9.37884 29 9.84616 29H30.1538C30.6212 29 31 28.5523 31 28C31 27.4477 30.6212 27 30.1538 27H9.84615Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFiles);
export default __webpack_public_path__ + "static/media/icon_Files.f8fe5b88fe974550af79befcfe0e9b2e.svg";
export { ForwardRef as ReactComponent };